'use es6';
/**
 * Returns it's first argument.
 *
 * @example
 * identity('something') === 'something'
 *
 * @param {any}  thing
 * @return {any}
 */

export default function identity(thing) {
  return thing;
}